import React from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk } from "redux-thunk";

import initialState from "./redux/initialState";
import rootReducer from "./redux/rootReducer";
import MstrAppRoutes from "./MstrAppRoutes";

const persistConfig = {
  key: "mstr",
  storage,
  blacklist: ["configuration"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
const store = createStoreWithMiddleware(persistedReducer, { ...initialState });
const persistor = persistStore(store);

const MstrAppHost = () => (
  <div
    style={{
      height: "100%",
      minHeight: 0,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    }}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MstrAppRoutes />
      </PersistGate>
    </Provider>
  </div>
);

export default MstrAppHost;
